import React, {useEffect} from 'react';
import {createPortal} from 'react-dom';
import PropTypes from 'prop-types';
import css from './Modal.module.scss';
import X02 from "../Icons/X02.jsx";
import {colors} from "../../utils/colors.js";

const Modal = ({
  isOpen,
  onClose,
  children,
  title,
  titleColor,
  className,
  style,
  width,
  size,
  stickyLayout = false,
  footer,
  closeButtonColor,
  bodyPadding = true
}) => {
  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscapeKey);
    }

    return () => {
      document.removeEventListener('keydown', handleEscapeKey);
    };
  }, [isOpen, onClose]);

  if (!isOpen) {
    return null;
  }

  const mergedStyle = width !== undefined ? {...style, width} : style;

  return createPortal(
    <div className={`${css.modalOverlay} ${className}`} onClick={onClose}>
      <div
        className={`${css.modalContent} ${size ? css[size] : ''} ${stickyLayout ? css.stickyLayout : ''}`}
        style={mergedStyle}
        onClick={e => e.stopPropagation()}
      >
        <div className={css.modalHeader}>
          <h3 style={{color: titleColor}}>{title}</h3>
          <button className={css.closeBtn} onClick={onClose}>
            <X02 color={closeButtonColor || colors.primaryColor} width={12} height={12} />
          </button>
        </div>
        <div className={`${css.modalBody} ${bodyPadding ? '' : css.noBodyPadding}`}>
          {children}
        </div>
        {footer &&
          <div className={css.modalFooter}>
            {footer}
          </div>
        }
      </div>
    </div>,
    document.body
  );
};

Modal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  title: PropTypes.node.isRequired,
  titleColor: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  stickyLayout: PropTypes.bool,
  footer: PropTypes.node,
  closeButtonColor: PropTypes.string,
  bodyPadding: PropTypes.bool,
};

export default Modal;
